<div *ngIf="field.eavAttributeOption.length >0 
  && !isTagField(field)
  &&field.frontendLabel!='Distributor'
  &&field.frontendLabel!='Metal Type'
  &&field.frontendLabel!='Products'
    &&field.frontendLabel!='Reason For Loss'
  &&field.frontendLabel!='Product'
&& field.attributeCode!='TimeZone'
&& field.frontendLabel!='Project Stage'
&& !propertyStatus
  &&field.frontendLabel!='Sequence'">

  <div *ngIf="field.frontendLabel!='Pincode Based' &&field.frontendLabel!='Project' 
    && !isTagField(field)
    &&field.attributeCode!='TimeZone'
    &&field.frontendLabel!='Business Type' && field.frontendLabel!='Industry Type'">

    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <mat-select [attr.guide]="'select-sel-1' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" [formControlName]="field.attributeCode" #singleSelect
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="fieldFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of fieldTypeList" [value]="item.optionId">
          {{item.eavAttributeOptionValue[0]?.value}}</mat-option>

      </mat-select>
      <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
      </div>
    </mat-form-field>

  </div>

  <div *ngIf="field.frontendLabel=='Pincode Based'">
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>


      <mat-select [attr.guide]="'select-sel-2' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="pincodeBasedFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredPicodeBasedList" [value]="opt.groupId">
          {{opt.groupName}}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>



</div>

<ng-container *ngIf="field.frontendLabel=='Sequence'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <mat-select [attr.guide]="'select-sel-3' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
      (openedChange)="onOpenedChange($event)">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="filterCtrl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredSequencesdropdownTypeList; let i=index;" [value]="opt.sequenceId">
        {{opt.sequenceName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>


<ng-container *ngIf="field.attributeCode=='TimeZone'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <mat-select [attr.guide]="'select-sel-4' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
      (openedChange)="onOpenedChange($event)">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="filterCtrl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredStatus" [value]="opt.value">
        {{opt.label}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="field.frontendLabel=='Distributor'">

</ng-container>




<ng-container *ngIf="field.frontendLabel=='Product' && !dealsProduct">

  <div fxFlex.gt-md="60" fxFle fxLayout="column">
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <mat-select [attr.guide]="'select-sel-5' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
          true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">

        <mat-option (onSelectionChange)="setPriceSelection($event,opt.entityId)" *ngFor="let opt of productList"
          [value]="opt.entityId">
          {{ opt.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>Product Price</mat-label>
      <input [attr.guide]="'select-inp-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" readonly
        matInput [formControl]="priceControl" />

    </mat-form-field>


  </div>

</ng-container>

<ng-container *ngIf="field.frontendLabel=='Products'">

  <div fxFlex.gt-md="60" fxFle fxLayout="column">
    <!-- <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
          true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode" 
          (openedChange)="onOpenedChange($event)">
        <mat-option 
        *ngFor="let opt of filteredproductNewTypeList"
          [value]="opt.name">
          {{ opt.name }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <mat-select [attr.guide]="'select-sel-6' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="productNewFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredproductNewTypeList" [value]="opt.name">
          {{opt.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</ng-container>

<ng-container *ngIf="field.frontendLabel=='Stage'">

  <div fxLayout="column">

    <div fxLayout="row" fxFlex="100">
      <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
        <mat-label>{{field.frontendLabel}}</mat-label>

        <mat-select [attr.guide]="'select-sel-7' + '__' + sanitizeUrl(url)"
          [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
          [formControlName]="field.attributeCode">

          <mat-option>
            <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
              placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId); onStageSelectionChange($event, opt.statusName)"
            *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusId">
            {{opt.statusName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxFlex="100" *ngIf="showReasonForLoss">
      <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
        <mat-label>Reason For Loss</mat-label>
        <mat-select [attr.guide]="'select-sel-8' + '__' + sanitizeUrl(url)" [required]="showReasonForLoss"
          formControlName="ReasonForLoss">

          <mat-option>
            <ngx-mat-select-search name="'Reason For Loss'" ngDefaultControl
              [formControl]="dealsCloseReasonFilterControl" placeholderLabel="Search"
              [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
            *ngFor="let opt of filteredDealsCloseReasonTypeList" [value]="opt.statusId">
            {{opt.statusName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>

  </div>

</ng-container>



<ng-container *ngIf="field.frontendLabel=='Distributor'" [formGroup]="group">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <mat-select [attr.guide]="'select-sel-9' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
   true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
      (openedChange)="onOpenedChange($event)">

      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="userdistributorFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredDistributorTypeList" [value]="opt.distributorId">
        {{opt.distributorName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="isMultiTagField(field)">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel || 'Tag Name'}}</mat-label>
    <mat-select [attr.guide]="'select-sel-tags' + '__' + sanitizeUrl(url)"
      [disableOptionCentering]="true" multiple #singleSelect [formControlName]="field.attributeCode"
      (selectionChange)="onTagsSelectedMulti($event)"
      (openedChange)="onOpenedChange($event)">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="tagsFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredtagsTypeList" [value]="opt.statusName">
        {{opt.statusName}}
      </mat-option>
    </mat-select>
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode)?.hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="isSingleTagField(field)">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel || 'Tags'}}</mat-label>
    <mat-select [attr.guide]="'select-sel-tags-single' + '__' + sanitizeUrl(url)"
      [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
      (openedChange)="onOpenedChange($event)">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="tagsFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredtagsTypeList" [value]="opt.statusId" (onSelectionChange)="onTagsSelectedSingle($event, opt)">
        {{opt.statusName}}
      </mat-option>
    </mat-select>
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode)?.hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</ng-container>

<div *ngIf="field.eavAttributeOption.length == 0
&& !isTagField(field)
&& !propertyStatus
  &&field.attributeCode!='TimeZone'
  &&field.frontendLabel!='Metal Type'
  &&field.frontendLabel!='Owner'
    &&field.frontendLabel!='Products'
    &&field.frontendLabel!='Stage'
  &&field.frontendLabel!='Product'&&field.frontendLabel!='Distributor'">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <ng-container
      *ngIf="field.frontendLabel!='Country of Manufacture'
     && field.frontendLabel!='sizeChart' && field.frontendLabel!='Deals Status'&& field.frontendLabel!='Stage'
     && field.frontendLabel!='Tax Class' && field.frontendLabel!='Apply MAP'&& field.frontendLabel!='Vendor'&& field.frontendLabel!='Lead Source'&&
      field.frontendLabel!='Lead Status'&& field.frontendLabel!='Country'&&field.frontendLabel!='State'&&field.frontendLabel!='City'&&field.frontendLabel!='Owner'&&field.frontendLabel!='Layout'&&field.frontendLabel!='Lecture'&&
      field.frontendLabel!='Doctor'&& field.frontendLabel!='Doctors' &&field.frontendLabel!='Category' &&field.frontendLabel!='Form'&&field.frontendLabel!='Priority'
       &&field.frontendLabel!='Tracker' &&field.frontendLabel!='Project' && (field.frontendLabel!='Status' || productStatus) && field.frontendLabel!='Pincode Based'&& field.frontendLabel!='Tags' && !isTagField(field)
       && field.frontendLabel!='Industry Type'&& field.frontendLabel!='Business Type' && field.frontendLabel!='Project Stage'">
      <mat-select [attr.guide]="'select-sel-10' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" [formControlName]="field.attributeCode">
        <mat-option *ngFor="let item of Option" [value]="item.regionId">{{item.defaultName}}</mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Country of Manufacture'">
      <mat-select [attr.guide]="'select-sel-11' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="countryFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredcountryTypeList" [value]="opt.countryName">
          {{opt.countryName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Country'">
      <mat-select [attr.guide]="'select-sel-12' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)" (selectionChange)="onLocationCountryChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="countrySearchControl"
            placeholderLabel="Search country..." [preventHomeEndKeyPropagation]="true"
            noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredLocationCountries" [value]="opt.name">
          {{opt.name}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Tax Class'">
      <mat-select [attr.guide]="'select-sel-13' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="taxclassFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredTaxClassList" [value]="opt.classId">
          {{opt.className}}
        </mat-option>
      </mat-select>
    </ng-container>


    <ng-container *ngIf="field.frontendLabel=='Vendor'">

      <mat-select [attr.guide]="'select-sel-14' + '__' + sanitizeUrl(url)" [disabled]="supDisabled" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="supplierFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredsupplierTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Lecture'">
      <mat-select [attr.guide]="'select-sel-15' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="lectureFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredlectureTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>


    <ng-container *ngIf="field.frontendLabel=='Doctor'">
      <mat-select [attr.guide]="'select-sel-16' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="doctorFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredDoctorTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Doctors'">
      <mat-select [attr.guide]="'select-sel-17' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="doctorFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredDoctorTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>
    <ng-container *ngIf="field.frontendLabel=='Tags'">
      <mat-select [attr.guide]="'select-sel-18' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)" multiple>
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="tagsFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="onTagsSelected($event,opt)" *ngFor="let opt of filteredtagsTypeList"
          [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Industry Type'">
      <mat-select [attr.guide]="'select-sel-19' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="industryFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredindustryTypeList" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Business Type'">
      <mat-select [attr.guide]="'select-sel-20' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="BusinessFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredBusinessTypeList" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Form'">
      <mat-select [attr.guide]="'select-sel-21' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="dynamicFormFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filtereddynamicFormTypeList" [value]="opt.formGroupId">
          {{opt.name}}
        </mat-option>
      </mat-select>
    </ng-container>


    <ng-container *ngIf="field.frontendLabel=='Priority'">
      <mat-select [attr.guide]="'select-sel-22' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="PriorityFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredPriorityTypeList" [value]="opt.priorityId">
          {{opt.priorityName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Tracker'">
      <mat-select [attr.guide]="'select-sel-23' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="trackerFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredTrackerTypeList" [value]="opt.trackerId">
          {{opt.trackerName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Project'">
      <mat-select [attr.guide]="'select-sel-24' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
       true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="projectsFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredProjectsTypeList" [value]="opt.id">
          {{opt.name}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Category'">

      <mat-select [attr.guide]="'select-sel-25' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
      true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="categoryFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredCategoryTypeList" [value]="opt.categoryId">
          {{ opt.categoryName }}
        </mat-option>
      </mat-select>
    </ng-container>





    <ng-container *ngIf="field.frontendLabel=='Layout'">

      <mat-select [attr.guide]="'select-sel-26' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="cmsFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredCmsTypeList;" [value]="opt.title">
          {{opt.title}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='sizeChart'">
      <mat-select [attr.guide]="'select-sel-27' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">
        <mat-option *ngFor="let item of sizeChart" [value]="item.sizeId">
          {{item.sizeChartName}}
        </mat-option>
      </mat-select>
    </ng-container>



    <ng-container *ngIf="field.frontendLabel=='Apply MAP'">
      <mat-select [attr.guide]="'select-sel-28' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">
        <mat-option *ngFor="let items of booleanField" [value]="items.value">
          {{items.viewValue}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Lead Source'">
      <mat-select [attr.guide]="'select-sel-29' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode"
        (openedChange)="onOpenedChange($event)">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadSourceFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredleadSourceTypeList" [value]="opt.sourceId">
          {{opt.sourceName}}
        </mat-option>
      </mat-select>

      <!-- <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" [formControlName]="field.attributeCode">
        <mat-option *ngFor="let lead of leadList" [value]="lead.sourceId">
          {{lead.sourceName}}
        </mat-option>
      </mat-select> -->
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Lead Status'">
      <mat-select [attr.guide]="'select-sel-30' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
          *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>




    <ng-container *ngIf="field.frontendLabel=='Status' && !taskStatusEnable && !propertyStatus && !productStatus">
      <mat-select [attr.guide]="'select-sel-31' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
          *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusName">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Status' && taskStatusEnable && !propertyStatus && !productStatus">
      <mat-select [attr.guide]="'select-sel-32' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
          *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Deals Status'">
      <mat-select [attr.guide]="'select-sel-33' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusName">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Project Stage'">
      <mat-select [attr.guide]="'select-sel-33_proj' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="projectStageFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredprojectStageTypeList" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>




    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>


  </mat-form-field>

</div>

<!-- State Selector - Appears after Country is selected -->
<div
  *ngIf="field.frontendLabel=='State' || (selectedCountryId && locationStates.length > 0 && field.frontendLabel=='Country')">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>State</mat-label>
    <mat-select [attr.guide]="'select-sel-34' + '__' + sanitizeUrl(url)"
      [required]="group.get('State')?.status == 'INVALID' ? true : false" [disableOptionCentering]="true" #singleSelect
      formControlName="State" (openedChange)="onOpenedChange($event)" (selectionChange)="onLocationStateChange($event)"
      [disabled]="!selectedCountryId || locationStates.length === 0">
      <mat-option>
        <ngx-mat-select-search ngDefaultControl [formControl]="stateSearchControl" placeholderLabel="Search state..."
          [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredLocationStates" [value]="opt.name">
        {{opt.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- City Selector - Appears after State is selected -->
<div
  *ngIf="field.frontendLabel=='City' || (selectedStateId && locationCities.length > 0 && field.frontendLabel=='Country')">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>City</mat-label>
    <mat-select [attr.guide]="'select-sel-35' + '__' + sanitizeUrl(url)"
      [required]="group.get('City')?.status == 'INVALID' ? true : false" [disableOptionCentering]="true" #singleSelect
      formControlName="City" (openedChange)="onOpenedChange($event)" (selectionChange)="onLocationCityChange($event)"
      [disabled]="!selectedStateId || locationCities.length === 0">
      <mat-option>
        <ngx-mat-select-search ngDefaultControl [formControl]="citySearchControl" placeholderLabel="Search city..."
          [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredLocationCities" [value]="opt.name">
        {{opt.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>



<ng-container *ngIf="propertyStatus">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <mat-select [attr.guide]="'select-sel-33_prop_status' + '__' + sanitizeUrl(url)"
      [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
      [formControlName]="field.attributeCode">
      <mat-option *ngFor="let opt of Option" [value]="opt.regionId">
        {{opt.defaultName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>



<ng-container>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

    <div *ngIf="init" fxFlex="60">

      <simple-dynamic-form [layout]="1" [formValue]="group.value" [status]="group.value.LeadStatus" [type]="newType"
        (submit)="onFormSubmitted($event)" [fields]="regConfig">

      </simple-dynamic-form>

    </div>

  </div>
</ng-container>

<ng-container *ngIf="field.frontendLabel=='Owner'&&!display">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <ng-container>
      <mat-select [attr.guide]="'select-sel-36' + '__' + sanitizeUrl(url)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="userOwnerFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="setOwner($event,opt)" *ngFor="let opt of filtereduserTypeList; let i=index;"
          [value]="opt.email">
          {{opt.email}}
        </mat-option>
      </mat-select>
    </ng-container>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="field.frontendLabel=='Metal Type'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <mat-select [attr.guide]="'select-sel-37' + '__' + sanitizeUrl(url)"
      [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
      [formControlName]="field.attributeCode">
      <mat-option (onSelectionChange)="setMetalPrice($event,item.ratePerGram)" *ngFor="let item of metalsType"
        [value]="item.metalRateId">
        {{item.metal}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>